export default "__VITE_ASSET__Bo5OASGD__"